import { Directive } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'np-drop-zone-label'
})
export class DropZoneLabelDirective { }
